<template>
  <section class="bg-accent overflow-hidden">
    <div class="section">
      <!-- Header -->
      <div class="text-center max-w-xl mx-auto mb-10">
        <p class="text-brand-300 font-semibold text-sm uppercase tracking-widest mb-1">What Clients Say</p>
        <h2 class="font-display text-3xl font-bold text-white mb-2">Customer Reviews</h2>
        <p class="text-cream-200/60 text-base">Real feedback from people we cook for every day</p>
      </div>

      <!-- Testimonial cards slider -->
      <div class="relative">
        <!-- Cards row -->
        <div
          ref="track"
          class="flex gap-5 overflow-x-auto scrollbar-hide pb-2 snap-x snap-mandatory"
        >
          <div
            v-for="t in approved"
            :key="t.id"
            class="flex-shrink-0 w-72 sm:w-80 md:w-96 snap-start bg-white/10 backdrop-blur-sm rounded-3xl p-4 sm:p-6 border border-white/10 hover:bg-white/15 transition-colors duration-200"
          >
            <!-- Stars -->
            <div class="flex gap-0.5 mb-3">
              <span
                v-for="i in 5"
                :key="i"
                class="text-lg"
                :class="i <= t.rating ? 'text-yellow-400' : 'text-white/20'"
              >★</span>
            </div>

            <!-- Message -->
            <p class="text-cream-100/90 leading-relaxed text-sm mb-5">"{{ t.message }}"</p>

            <!-- Author -->
            <div class="flex items-center gap-3 pt-4 border-t border-white/10">
              <div class="w-10 h-10 rounded-full bg-brand flex items-center justify-center text-white font-bold font-display text-base flex-shrink-0">
                {{ t.name.charAt(0) }}
              </div>
              <div>
                <p class="font-semibold text-white text-sm leading-tight">{{ t.name }}</p>
                <p class="text-cream-200/50 text-xs">{{ t.location }} · {{ formatDate(t.date) }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Gradient fade edges -->
        <div class="pointer-events-none absolute inset-y-0 left-0 w-4 sm:w-6 lg:w-8 bg-gradient-to-r from-accent to-transparent" />
        <div class="pointer-events-none absolute inset-y-0 right-0 w-4 sm:w-6 lg:w-8 bg-gradient-to-l from-accent to-transparent" />
      </div>

      <!-- CTA to submit review -->
      <div class="text-center mt-10">
        <p class="text-cream-200/50 text-sm mb-3">Had a great meal? Tell us about it!</p>
        <router-link to="/contact#review" class="btn-primary text-sm px-6 py-2.5">
          Leave a Review
        </router-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'TestimonialsSection',
  setup () {
    const store = useStore()
    const approved = computed(() => store.getters['testimonials/approved'])

    const formatDate = (date: string) =>
      new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })

    return { approved, formatDate }
  }
})
</script>

<style scoped>
.scrollbar-hide::-webkit-scrollbar { display: none; }
.scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
</style>
